import { numberUtil } from '@goodfynd/utils';

import config from '../config';
import images from '../config/images';
import type { ScheduleItem } from '../types/schedule';

import * as dateUtil from './date-util';
import { getDateRangeDisplay } from './date-util';

export const getAddressLabel = (
  eventItem: ScheduleItem,
  fallback = 'Get Directions'
) => {
  if (eventItem.pickupLocation?.address) {
    return eventItem.pickupLocation.address;
  }

  if (eventItem.pickupLocation?.city && eventItem.pickupLocation?.state) {
    return `${eventItem.pickupLocation.city}, ${eventItem.pickupLocation.state}`;
  }

  return fallback;
};
export const getEventDateFormat = (eventItem: ScheduleItem) => {
  const parts = [];
  const date = eventItem.date || eventItem.start;
  if (date) {
    parts.push(dateUtil.format(date, config.dateFormats.weekDayMonthDayYear));
  }

  parts.push(dateUtil.getTimeRangeDisplay(eventItem.start, eventItem.end));
  return parts.join(' ');
};

export const getEventTimeLabel = ({ end, start }: IntervalDates) => {
  let label = dateUtil.format(start as Date, config.dateFormats.timeSpace);
  label += config.unicode.dashEnPadded;
  label += dateUtil.format(end as Date, config.dateFormats.timeSpace);
  return label;
};

export const getLeadDateTimes = (
  dates: string[],
  format?: (end: string) => {
    default?: string;
    start?: string;
    end?: string;
  }
) => {
  const firstDateParts = dates
    .find((date) => dateUtil.isFuture(date.split(' ')[0]))
    ?.split(' ');
  const lastDateParts = dates.slice(1)[dates.length - 2]?.split(' ');

  const start = firstDateParts?.[0];
  const end = lastDateParts?.[0];

  let endDate: Date | undefined;
  let timeRangeDisplay = firstDateParts
    ?.slice(1)
    .join(' ')
    .replace(/^\[/, '')
    .replace(/\]$/, '');
  if (timeRangeDisplay?.startsWith('- ')) {
    timeRangeDisplay = timeRangeDisplay.replace(/^\- /, '');
    const rangeParts = timeRangeDisplay.split(' ');
    endDate = new Date(rangeParts[0]);
    timeRangeDisplay = rangeParts.slice(1).join(' ').replace(/^\[/, '');
  }

  return {
    start,
    end,
    endDate,
    dateRangeDisplay: start
      ? getDateRangeDisplay(
          start,
          end,
          '',
          format?.(end) ?? {
            start: end
              ? config.dateFormats.monthDayShort
              : config.dateFormats.monthDayYearShort,
            end: config.dateFormats.monthDayYearShort,
          }
        )
      : undefined,
    timeRangeDisplay,
  };
};

export const getImageFallback = () => {
  const imageKeys = Object.keys(images.fallbacks.event);
  const imageKey = imageKeys[
    numberUtil.random(0, imageKeys.length - 1)
  ] as keyof typeof images.fallbacks.event;
  return images.fallbacks.event[imageKey];
};

export const getAverageCost = (quantity: number, total: number) => {
  return Math.ceil(total / quantity);
};
